import { SITE } from "@/lib/site";

export default function About() {
  return (
    <section id="despre" data-testid="about-section" className="relative py-24 lg:py-36 px-5 lg:px-10 bg-[#fcf3e6] ad-grain">
      <div className="max-w-4xl mx-auto text-center">
        <div className="text-[#048a93] uppercase text-[11px] tracking-[0.32em] font-semibold mb-5" data-testid="about-eyebrow">
          <span className="inline-block h-px w-10 bg-[#048a93] align-middle mr-3" />
          Despre AriDanya
          <span className="inline-block h-px w-10 bg-[#048a93] align-middle ml-3" />
        </div>
        <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-[#012a2d] leading-[1.05]" data-testid="about-title">
          Un colț de <span className="italic text-[#048a93]">tropic</span> în inima Giuleștiului.
        </h2>

        <div className="mt-10 space-y-5 font-sans-ui text-base lg:text-lg text-[#1a2421]/80 leading-relaxed max-w-2xl mx-auto">
          <p>
            AriDanya Garden este locația perfectă pentru petreceri private, aniversări, botezuri, zile de naștere și întâlniri cu prietenii. Am gândit fiecare detaliu astfel încât, din momentul în care intri pe poartă, să simți că ai ajuns într-o vacanță scurtă.
          </p>
          <p>
            Te așteaptă o piscină de 10×5m, un tobogan gonflabil pentru cei mici, o terasă generoasă pentru masă, un bar exterior din lemn natural, o vatră de foc și o grădină verde — toate puse cap la cap într-un decor tropical, elegant și prietenos.
          </p>
        </div>

        <p className="mt-10 font-serif-display italic text-2xl lg:text-3xl text-[#048a93]">
          „Aici nu organizăm doar evenimente — creăm amintiri.”
        </p>

        <dl className="mt-14 grid grid-cols-2 gap-6 max-w-xl mx-auto">
          <div className="border-l-2 border-[#048a93] pl-4 text-left">
            <dt className="text-[11px] uppercase tracking-[0.25em] text-[#048a93] font-semibold">Capacitate</dt>
            <dd className="font-serif-display text-3xl mt-1 text-[#012a2d]">70 persoane</dd>
          </div>
          <div className="border-l-2 border-[#048a93] pl-4 text-left">
            <dt className="text-[11px] uppercase tracking-[0.25em] text-[#048a93] font-semibold">Locație</dt>
            <dd className="font-serif-display text-3xl mt-1 text-[#012a2d]">{SITE.location.split(',')[0]}</dd>
          </div>
        </dl>
      </div>
    </section>
  );
}
